const AUDIT_LOG_PARAMS = {
  ID: 'id',
  TARGET_ID: 'targetId',
  TARGET_TYPE: 'targetType',
};

export const ROUTES = {
  CLIENTS_MANAGEMENT: {
    PATH: '/clients-management',
    SUB_PATH: {
      CLIENTS: {
        PATH: '/clients-management/clients',
        SUB_PATH: {
          CLIENT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/clients-management/clients/:id',
            SUB_PATH: {
              AUDIT_LOGS: {
                PARAMS: AUDIT_LOG_PARAMS,
                PATH: `/clients-management/clients/:id/audit-logs/:targetType`,
                SUB_PATH: {
                  CHILD: `/clients-management/clients/:id/audit-logs/:targetType/:targetId`,
                  PARAMS: AUDIT_LOG_PARAMS,
                },
              },
              MANUAL_PAYOUT: {
                PARAMS: {
                  ID: 'id',
                },
                PATH: '/clients-management/clients/:id/manual-payout',
              },
              MANUAL_TRANSACTION: {
                PARAMS: {
                  ID: 'id',
                },
                PATH: '/clients-management/clients/:id/manual-transaction',
              },
            },
          },
          CREATE: '/clients-management/clients/new',
          EDIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/clients-management/clients/:id/edit',
          },
          MANUAL_PAYOUT: {
            PATH: '/clients-management/clients/manual-payout',
          },
          MANUAL_TRANSACTION: {
            PATH: '/clients-management/clients/manual-transaction',
          },
        },
      },
      CLIENTS_INSTRUMENTS: {
        PATH: '/clients-management/clients-instruments',
      },
    },
  },
  DASHBOARDS: {
    PATH: '/dashboards-folder',
    SUB_PATH: {
      COPY_DASHBOARD_FOLDER: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/dashboards-folder/:id/copy',
      },
      CREATE_DASHBOARD_FOLDER: '/dashboards-folder/new',
      EDIT_DASHBOARD_FOLDER: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/dashboards-folder/:id/edit',
      },
      VIEW: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/dashboards-folder/:id',
        SUB_PATH: {
          DASHBOARD: {
            CREATE_DASHBOARD: {
              PARAMS: {
                ID: 'id',
              },
              PATH: '/dashboards-folder/:id/dashboard/new',
            },
            EDIT_DASHBOARD: {
              PARAMS: {
                DASHBOARD_ID: 'dashboardId',
                ID: 'id',
              },
              PATH: '/dashboards-folder/:id/dashboard/:dashboardId/edit',
            },
            VIEW: {
              PARAMS: {
                DASHBOARD_ID: 'dashboardId',
                ID: 'id',
              },
              PATH: '/dashboards-folder/:id/dashboard/:dashboardId',
            },
          },
          GRAPH: {
            CREATE_GRAPH: {
              PARAMS: {
                DASHBOARD_ID: 'dashboardId',
                ID: 'id',
              },
              PATH: '/dashboards-folder/:id/dashboard/:dashboardId/graph/new',
            },
            EDIT_GRAPH: {
              PARAMS: {
                DASHBOARD_ID: 'dashboardId',
                GRAPH_ID: 'graphId',
                ID: 'id',
              },
              PATH: '/dashboards-folder/:id/dashboard/:dashboardId/graph/:graphId/edit',
            },
          },
        },
      },
    },
  },
  FORGOT_PASSWORD: {
    PATH: '/forgot-password',
  },
  HOME: {
    PATH: '/',
  },
  INTEGRATIONS: {
    PATH: '/integrations',
    SUB_PATH: {
      INTEGRATION_BUILDER: {
        PATH: '/integrations/integration-builder',
        SUB_PATH: {
          ADAPTER: {
            SUB_PATH: {
              VIEW: {
                PARAMS: { CODE: 'code' },
                PATH: '/integrations/integration-builder/adapter/:code',
                SUB_PATH: {
                  OPERATION: {
                    CREATE: {
                      PARAMS: { CODE: 'code' },
                      PATH: '/integrations/integration-builder/adapter/:code/operation/new',
                    },
                    EDIT: {
                      PARAMS: { CODE: 'code', ID: 'id' },
                      PATH: '/integrations/integration-builder/adapter/:code/operation/:id',
                    },
                  },
                },
              },
            },
          },
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/integrations/integration-builder/adapter/:id/audit-logs/:targetType`,
          },
        },
      },
      RESULT_CODES: {
        PATH: '/integrations/result-code-mapping',
        SUB_PATH: {
          BULK_CREATE: '/integrations/result-code-mapping/bulk-create',
        },
      },
    },
  },
  INVOICES: {
    PATH: '/invoices',
    SUB_PATH: {
      AUDIT_LOGS: {
        PARAMS: AUDIT_LOG_PARAMS,
        PATH: `/invoices/billing-contract/:id/audit-logs/:targetType`,
      },
      CREATE: '/invoices/billing-contract/new',
      EDIT: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/invoices/billing-contract/:id/edit',
      },
      GATEWAY_INVOICE: {
        AUDIT_LOGS: {
          PARAMS: AUDIT_LOG_PARAMS,
          PATH: `/invoices/gateway-invoice/:id/audit-logs/:targetType`,
        },
        EDIT: {
          PARAMS: {
            ID: 'id',
          },
          PATH: '/invoices/gateway-invoice/:id',
        },
      },
    },
  },
  MERCHANTS: {
    PATH: '/merchants',
    SUB_PATH: {
      CREATE: '/merchants/new',
      MERCHANT: {
        PARAMS: { ID: 'id' },
        PATH: '/merchants/:id',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/merchants/:id/audit-logs/:targetType`,
            SUB_PATH: {
              CHILD: `/merchants/:id/audit-logs/:targetType/:targetId`,
              PARAMS: AUDIT_LOG_PARAMS,
            },
          },
          CASHIER_LIMITS: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/cashier-limits/new',
          },
          CASHIER_PAYMENT_METHOD_GROUPS: {
            CREATE: {
              PARAMS: { ID: 'id' },
              PATH: '/merchants/:id/cashier-payment-method-groups/new',
            },
            EDIT: {
              PARAMS: { GROUP_ID: 'groupId', ID: 'id' },
              PATH: '/merchants/:id/cashier-payment-method-groups/:groupId',
            },
          },
          CASHIER_PAYMENT_METHODS: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/cashier-payment-methods/new',
          },
          CASHIER_SETTINGS: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/cashier-settings/new',
          },
          CHANGE_PAYMENT_METHOD: {
            CREATE: {
              PARAMS: { ID: 'id' },
              PATH: '/merchants/:id/change-payment-method/change-rule/new',
            },
            EDIT: {
              PARAMS: { ID: 'id', RULE_ID: 'ruleId' },
              PATH: '/merchants/:id/change-payment-method/change-rule/:ruleId/edit',
            },
          },
          EDIT: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/edit',
          },
          MERCHANT_CUSTOM_ACTIONS: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/custom-actions/new',
          },
          MERCHANT_OUTPUT_CHANNELS: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/output-channels/new',
          },
          PAYMENT_LINK: {
            CREATE: {
              PARAMS: { ID: 'id' },
              PATH: '/merchants/:id/payment-link/new',
            },
            EDIT: {
              PARAMS: { ID: 'id', LINK_ID: 'linkId' },
              PATH: '/merchants/:id/payment-link/:linkId',
            },
          },
          ROUTING_CASCADING: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/routing-cascading/routing-ruleset/new',
          },
          STYLIZATION: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/stylization',
            SUB_PATH: {
              HOSTED_FIELDS_THEME: {
                PATH: '/merchants/:id/stylization/hosted-fields-theme',
                SUB_PATH: {
                  CREATE: {
                    PARAMS: { ID: 'id' },
                    PATH: '/merchants/:id/stylization/hosted-fields-theme/new',
                  },
                  EDIT: {
                    PARAMS: { ID: 'id', THEME_ID: 'themeId' },
                    PATH: '/merchants/:id/stylization/hosted-fields-theme/:themeId',
                  },
                },
              },
              THEME: {
                PATH: '/merchants/:id/stylization/theme',
                SUB_PATH: {
                  CREATE: {
                    PARAMS: { ID: 'id' },
                    PATH: '/merchants/:id/stylization/theme/new',
                  },
                  EDIT: {
                    PARAMS: { ID: 'id', THEME_ID: 'themeId' },
                    PATH: '/merchants/:id/stylization/theme/:themeId',
                  },
                },
              },
            },
          },
          TERMINAL_API_CREDENTIALS: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants/:id/terminal-Api-Credentials/new',
          },
        },
      },
    },
  },
  MERCHANTS_SETTINGS: {
    PATH: '/merchants-settings',
    SUB_PATH: {
      CASHIER_LIMITS: {
        PATH: '/merchants-settings/cashier-limits',
        SUB_PATH: {
          CREATE_LIMIT: {
            PATH: '/merchants-settings/cashier-limits/new',
          },
          EDIT_LIMIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/merchants-settings/cashier-limits/:id/edit/',
          },
        },
      },
      CASHIER_SETTINGS: {
        PATH: '/merchants-settings/cashier-settings',
        SUB_PATH: {
          CREATE: '/merchants-settings/cashier-settings/new',
          EDIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/merchants-settings/cashier-settings/:id/edit',
          },
        },
      },
      PAYMENT_METHODS: {
        PATH: '/merchants-settings/payment-methods',
        SUB_PATH: {
          CREATE: '/merchants-settings/payment-methods/new',
          EDIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/merchants-settings/payment-methods/:id/edit',
          },
          VIEW: {
            PARAMS: { ID: 'id' },
            PATH: '/merchants-settings/payment-methods/:id',
          },
        },
      },
    },
  },
  MESSAGE_CENTER: {
    PATH: '/message-center',
    SUB_PATH: {
      USER_GROUPS: {
        PATH: `/message-center/user-groups`,
      },
    },
  },
  NOT_FOUND: {
    PATH: '/not-found',
  },
  NOTIFICATION_HISTORY: {
    PATH: '/notification-history',
  },
  ORGANIZATIONS: {
    PATH: '/organizations',
    SUB_PATH: {
      CREATE: '/organizations/new',
      ORGANIZATION: {
        PARAMS: { ID: 'id' },
        PATH: '/organizations/:id',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/organizations/:id/audit-logs/:targetType`,
            SUB_PATH: {
              CHILD: `/organizations/:id/audit-logs/:targetType/:targetId`,
              PARAMS: AUDIT_LOG_PARAMS,
            },
          },
          EDIT: {
            PARAMS: { ID: 'id' },
            PATH: '/organizations/:id/edit',
          },
          LEGAL_ENTITY_CREATE: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/organizations/:id/legal-entity/new',
          },
          LEGAL_ENTITY_EDIT: {
            PARAMS: { ID: 'id', LEGAL_ENTITY_ID: 'legalEntityId' },
            PATH: '/organizations/:id/legal-entity/:legalEntityId',
          },
        },
      },
    },
  },
  PERMISSION_DENIED: {
    PATH: '/403',
  },
  PSP_MANAGEMENT: {
    PATH: '/psp-management',
    SUB_PATH: {
      PSP: {
        PATH: '/psp-management/psp',
        SUB_PATH: {
          VIEW: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/psp-management/psp/:id',
            SUB_PATH: {
              AUDIT_LOGS: {
                PARAMS: AUDIT_LOG_PARAMS,
                PATH: `/psp-management/psp/:id/audit-logs/:targetType`,
                SUB_PATH: {
                  CHILD: `/psp-management/psp/:id/audit-logs/:targetType/:targetId`,
                  PARAMS: AUDIT_LOG_PARAMS,
                },
              },
            },
          },
        },
      },
      TERMINAL_LINKS_GROUPS: {
        PATH: '/psp-management/terminal-links-groups',
        TERMINAL_LINKS_GROUP: {
          PARAMS: {
            ID: 'id',
          },
          PATH: '/psp-management/terminal-links-groups/:id',
          SUB_PATH: {
            AUDIT_LOGS: {
              PARAMS: AUDIT_LOG_PARAMS,
              PATH: `/psp-management/terminal-links-groups/:id/audit-logs/:targetType`,
              SUB_PATH: {
                CHILD: `/psp-management/terminal-links-groups/:id/audit-logs/:targetType/:targetId`,
                PARAMS: AUDIT_LOG_PARAMS,
              },
            },
            TERMINAL_LINK: {
              PARAMS: {
                ID: 'id',
              },
              PATH: '/psp-management/terminal-links-groups/:id/terminal-links',
            },
          },
        },
      },
      TERMINAL_LINKS_PARAMETERS: {
        PATH: '/psp-management/terminal-links-parameters',
      },
      TERMINALS: {
        PATH: '/psp-management/terminals',
        SUB_PATH: {
          TERMINAL: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/psp-management/terminals/:id',
            SUB_PATH: {
              AUDIT_LOGS: {
                PARAMS: AUDIT_LOG_PARAMS,
                PATH: `/psp-management/terminals/:id/audit-logs/:targetType`,
                SUB_PATH: {
                  CHILD: `/psp-management/terminals/:id/audit-logs/:targetType/:targetId`,
                  PARAMS: AUDIT_LOG_PARAMS,
                },
              },
            },
          },
        },
      },
      TERMINALS_LINKS: {
        COPY: '/psp-management/terminals-links/copy',
        CREATE: '/psp-management/terminals-links/new',
        GROUP_CREATE_SC: '/psp-management/terminals-links/group-create-sc',
        GROUP_EDIT_RP: '/psp-management/terminals-links/group-edit-rp',
        PATH: '/psp-management/terminals-links',
        TERMINAL_LINK: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/psp-management/terminals-links/:id/audit-logs/:targetType`,
            SUB_PATH: {
              CHILD: `/psp-management/terminals-links/:id/audit-logs/:targetType/:targetId`,
              PARAMS: AUDIT_LOG_PARAMS,
            },
          },
          PARAMS: {
            ID: 'id',
          },
          PATH: '/psp-management/terminals-links/:id',
          REQUIRED_PARAMETERS: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/psp-management/terminals-links/:id/required-parameters',
          },
          SETTLEMENT_CONFIGURATIONS: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/psp-management/terminals-links/:id/settlement-configurations',
          },
        },
      },
      TERMINALS_LINKS_LIMITS: {
        COPY: '/psp-management/terminals-links-limits/copy',
        PATH: '/psp-management/terminals-links-limits',
      },
    },
  },
  RECONCILIATION: {
    PATH: '/reconciliation',
    SUB_PATH: {
      CREATE_RECONCILIATION_FOLDER: '/reconciliation/folder/new',
      EDIT_RECONCILIATION_FOLDER: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/reconciliation/folder/:id/edit',
      },
      VIEW: {
        PARAMS: { ID: 'id' },
        PATH: '/reconciliation/folder/:id',
        SUB_PATH: {
          FILE: {
            PARAMS: { FILE_ID: 'fileId', ID: 'id' },
            PATH: '/reconciliation/folder/:id/file/:fileId',
          },
          MAPPING: {
            PARAMS: { ID: 'id' },
            PATH: '/reconciliation/folder/:id/mapping',
          },
        },
      },
    },
  },
  RESET_PASSWORD: {
    PATH: '/reset-password',
  },
  SET_PASSWORD: {
    PATH: '/password/set',
  },
  SETTINGS: {
    PATH: '/settings',
    SUB_PATH: {
      AUTH_AUDIT_LOGS: {
        PATH: '/settings/auth-audit-logs',
      },
      NOTIFICATIONS: {
        PATH: '/settings/notifications',
        SUB_PATH: {
          COPY_TEMPLATES: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/settings/notifications/templates/:id/copy',
          },
          CREATE_NOTIFICATION: '/settings/notifications/notification/new',
          CREATE_TEMPLATES: '/settings/notifications/templates/new',
          EDIT_NOTIFICATION: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/settings/notifications/notification/:id/edit',
          },
          EDIT_TEMPLATES: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/settings/notifications/templates/:id/edit',
          },
        },
      },
      PORTAL_SETTINGS: {
        PATH: '/settings/portal-settings',
      },
      USERS_AUDIT_LOGS: {
        PATH: '/settings/audit-logs',
      },
    },
  },
  SETTLEMENT: {
    CREATE: '/settlement/settlement-contracts/new',
    EDIT: {
      PARAMS: {
        ID: 'id',
      },
      PATH: '/settlement/settlement-contracts/:id/edit',
    },
    PATH: '/settlement',
    SETTLEMENT_CONTRACTS: {
      PATH: '/settlement/settlement-contracts',
      SETTLEMENT_CONTRACT: {
        AUDIT_LOGS: {
          PARAMS: AUDIT_LOG_PARAMS,
          PATH: `/settlement/settlement-contracts/:id/audit-logs/:targetType`,
        },
        PARAMS: {
          ID: 'id',
        },
        PATH: '/settlement/settlement-contracts/:id',
      },
    },
  },
  SHORT_LINK: {
    PARAMS: {
      CODE: 'code',
    },
    PATH: '/short-link/:code',
  },
  SIGN_IN: {
    PATH: '/login',
  },
  SOMETHING_WRONG: {
    PATH: '/something-wrong',
  },
  TRAFFIC_MANAGEMENT: {
    PATH: '/traffic-management',
    SUB_PATH: {
      BIN_GROUPS: {
        PATH: '/traffic-management/bin-groups',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/traffic-management/bin-groups/audit-logs/:targetType/:targetId`,
          },
          CREATE: '/traffic-management/bin-groups/new',
          EDIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/traffic-management/bin-groups/:id/edit',
          },
        },
      },
      BLACKLISTS: {
        PATH: '/traffic-management/blacklists',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/traffic-management/blacklists/audit-logs/:targetType/:targetId`,
          },
          CREATE_DEVICE: '/traffic-management/blacklists/devices/new',
          CREATE_EMAIL: '/traffic-management/blacklists/emails/new',
          CREATE_IP_ADDRESS: '/traffic-management/blacklists/ip-address/new',
          CREATE_MASK: '/traffic-management/blacklists/card-masks/new',
          CREATE_PAN: '/traffic-management/blacklists/pans/new',
          CREATE_TRANSACTION_DEVICE: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/traffic-management/blacklists/devices/:id/new',
          },
          CREATE_TRANSACTION_EMAIL: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/blacklists/emails/:id/new',
          },
          CREATE_TRANSACTION_IP_ADDRESS: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/blacklists/ip-address/:id/new',
          },
          CREATE_TRANSACTION_MASK: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/blacklists/card-masks/:id/new',
          },
          CREATE_TRANSACTION_PAN: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/blacklists/pans/:id/new',
          },
        },
      },
      CHANGE_PAYMENT_METHOD_RULES: {
        PATH: '/traffic-management/change-payment-method-rules',
        SUB_PATH: {
          BULK_COPY: '/traffic-management/change-payment-method-rules/bulk-copy',
          BULK_CREATE: '/traffic-management/change-payment-method-rules/bulk-create',
        },
      },
      COUNTRY_GROUPS: {
        PATH: '/traffic-management/country-groups',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/traffic-management/country-groups/audit-logs/:targetType/:targetId`,
          },
          COPY: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/traffic-management/country-groups/:id/copy',
          },
          CREATE: '/traffic-management/country-groups/new',
          EDIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/traffic-management/country-groups/:id/edit',
          },
        },
      },
      MERCHANT_GROUPS: {
        PATH: '/traffic-management/merchant-groups',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/traffic-management/merchant-groups/audit-logs/:targetType/:targetId`,
          },
          CREATE: '/traffic-management/merchant-groups/new',
          EDIT: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/merchant-groups/:id/edit',
          },
          MERCHANT_GROUP: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/merchant-groups/:id',
          },
        },
      },
      METADATA_TEMPLATES: {
        PATH: '/traffic-management/metadata-templates',
        SUB_PATH: {
          CREATE: '/traffic-management/metadata-templates/new',
          EDIT: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/metadata-templates/:id/edit',
          },
        },
      },
      ROUTING_RULESET: {
        PATH: '/traffic-management/routing-ruleset',
        SUB_PATH: {
          BULK_COPY: '/traffic-management/routing-ruleset/bulk-copy',
          COPY: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/traffic-management/routing-ruleset/:id/copy',
          },
          COPY_TO_MERCHANT: '/traffic-management/routing-ruleset/copy-to-merchant',
          CREATE: '/traffic-management/routing-ruleset/new',
          EDIT: {
            PARAMS: { ID: 'id' },
            PATH: '/traffic-management/routing-ruleset/:id/edit',
          },
        },
      },
    },
  },
  TRANSACTIONS: {
    PATH: '/transactions',
    SUB_PATH: {
      VIEW: {
        PARAMS: { ID: 'id' },
        PATH: '/transactions/:id',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/transactions/:id/audit-logs/:targetType`,
          },
          ROUTING_HISTORY: {
            PARAMS: {
              ID: 'id',
            },
            PATH: `/transactions/:id/routing-history`,
          },
        },
      },
    },
  },
  USER_MANAGEMENT: {
    PATH: '/user-management',
    SUB_PATH: {
      CREATE_USER: '/user-management/users/new',
      USER: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/user-management/users/:id',
        SUB_PATH: {
          AUDIT_LOGS: {
            PARAMS: AUDIT_LOG_PARAMS,
            PATH: `/user-management/users/:id/audit-logs/:targetType`,
          },
          EDIT: {
            PARAMS: {
              ID: 'id',
            },
            PATH: '/user-management/users/:id/edit',
          },
        },
      },

      AUDIT_LOGS: {
        PARAMS: AUDIT_LOG_PARAMS,
        PATH: `/user-management/roles-and-permissions/roles/audit-logs/:targetType/:targetId`,
      },
      CREATE_ROLE: '/user-management/roles-and-permissions/roles/new',
      EDIT_ROLE: {
        PARAMS: {
          ID: 'id',
        },
        PATH: '/user-management/roles-and-permissions/roles/:id/edit',
      },
    },
  },
  USER_MANUAL: {
    PATH: '/user-manual',
    SUB_PATH: {
      PARAMS: {
        ID: 'id',
      },
      PATH: '/user-manual/:id',
    },
  },
};

export const UNAUTHORIZED_ROUTES = [
  ROUTES.HOME.PATH,
  ROUTES.NOT_FOUND.PATH,
  ROUTES.SIGN_IN.PATH,
  ROUTES.FORGOT_PASSWORD.PATH,
  ROUTES.RESET_PASSWORD.PATH,
  ROUTES.SET_PASSWORD.PATH,
  ROUTES.SOMETHING_WRONG.PATH,
  ROUTES.PERMISSION_DENIED.PATH,
];
